import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n)=>{let{data:r}=await t.get(`/roles/scope`,{params:{scope:e(n)}});return r};export{t as getScopeRole};
//# sourceMappingURL=get-scope-role.mjs.map